import {
  API_ROUTES,
  catchUpAskResultSchema,
  catchUpReportSchema,
  catchUpRunSchema,
  catchUpSignSchema,
} from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from './queries.js';

/** Catch up the books. */

export const catchUpKeys = {
  report: (organizationId: string) => ['catch-up', organizationId] as const,
};

export const catchUpReportQuery = (organizationId: string) =>
  queryOptions({
    queryKey: catchUpKeys.report(organizationId),
    queryFn: ({ signal }) =>
      apiClient.request({
        path: API_ROUTES.catchUp.report(organizationId),
        schema: catchUpReportSchema,
        signal,
      }),
    enabled: organizationId !== '',
  });

export const runCatchUp = (organizationId: string) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.catchUp.run(organizationId),
    schema: catchUpRunSchema,
    body: {},
  });

export const signCatchUp = (organizationId: string) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.catchUp.sign(organizationId),
    schema: catchUpSignSchema,
    body: {},
  });

export const askAboutMissingPaper = (organizationId: string, bankTransactionIds: string[]) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.catchUp.ask(organizationId),
    schema: catchUpAskResultSchema,
    body: { bankTransactionIds },
  });
